const { START, STOP, NEXT_OR_PREV } = require('store/types');

export const startTour = (data) => ({
  type: START,
  payload: data,
});

export const stopTour = (data) => ({
  type: STOP,
  payload: data,
});

export const nextprevTour = (data) => ({
  type: NEXT_OR_PREV,
  payload: data,
});
